import * as tslib_1 from "tslib";
import { IgrHeader } from "./igr-header";
import { TextHeader } from "./TextHeader";
/**
 * Represents a class used to configure the appearance of a text column header cells.
*/
var IgrTextHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTextHeader, _super);
    function IgrTextHeader(props) {
        return _super.call(this, props) || this;
    }
    IgrTextHeader.prototype.createImplementation = function () {
        return new TextHeader();
    };
    Object.defineProperty(IgrTextHeader.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrTextHeader;
}(IgrHeader));
export { IgrTextHeader };
//# sourceMappingURL=igr-text-header.js.map
